import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-submission25',
  templateUrl: './submission.component.html',
  styleUrls: ['./submission.component.css']
})
export class SubmissionComponent25 implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
